var appConfig = {
  appId: 'SaaSPortalApplication',
  appName: 'SaaSPortalApplication',
  appVersion: '1.0.0'
};
